module.exports = __webpack_public_path__ + "img/arscp_logo_white.76474f87.png";